import React from 'react';
import './ChatWindow.css';

function TypingIndicator() {
  return (
    <div className="typing-indicator">
      <span>AI is typing</span>
      <div className="typing-dots">
        <div className="typing-dot"></div>
        <div className="typing-dot"></div>
        <div className="typing-dot"></div>
      </div>
    </div>
  );
}

export default TypingIndicator;
